import { useRouter } from 'next/router';
import LayoutV2 from 'components/common/LayoutV2';
import CommunityView from 'components/community/gridV2/CommunityView';
import { CommunityFilter } from 'components/menuV2/NavCommunityFilters';

export default function CommunityPageWithTag() {
  const router = useRouter();

  const tag = router.query.tag as CommunityFilter;

  return (
    <LayoutV2
      title="Marketplace"
      showCommunitySearch
      showCommunityFilters
      selectedCommunityFilter={tag as CommunityFilter}
    >
      <CommunityView selectedTag={tag} />
    </LayoutV2>
  );
}
